import clsx from 'clsx'
import SaveMoneyTime from '../../assets/save-moneytime-cabana.svg'
import React from 'react'

interface ExtendedStayBadgeProps {
  onClick: () => void
  className?: string
}

const ExtendedStayBadge: React.FC<ExtendedStayBadgeProps> = ({
  onClick,
  className
}) => {
  return (
    <div
      className={clsx(
        'flex flex-row items-center justify-center gap-2 rounded-lg bg-secondary/40 cursor-pointer',
        'text-xs p-1 sm:p-2',
        className
      )}
      onClick={onClick}
      role="button"
      tabIndex={0}
      aria-label="Extended stay badge"
      onKeyDown={e => e.key === 'Enter' && onClick()}
    >
      <img
        src={SaveMoneyTime}
        alt="Save money time"
        className="h-5 w-5 opacity-50"
      />
      <span className="text-primary font-medium opacity-100">
        Stay Longer. Save More.
      </span>
    </div>
  )
}

export default ExtendedStayBadge
